import { useState, useEffect } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import DashboardNavbar from "./dashboard-navbar";
import { DashboardSidebar } from "./dashboard-sidebar";
import AdminAlerts from "./AdminAlerts";
import LoginToast from "./LoginToast";

const DashboardLayoutRoot = styled("div", {
    shouldForwardProp: (prop) => prop !== "isSidebarOpen"
})(({ theme, isSidebarOpen }) => ({
    display: "flex",
    flex: "1 1 auto",
    maxWidth: "100%",
    paddingTop: 56,
    transition: theme.transitions.create(["padding-left"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
    }),
    [theme.breakpoints.up("lg")]: {
        paddingLeft: isSidebarOpen ? 240 : 0
    }
}));

export const DashboardLayout = (props) => {
    const { children } = props;
    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"), {
        defaultMatches: true,
        noSsr: false
    });
    const [isSidebarOpen, setSidebarOpen] = useState(lgUp);

    useEffect(() => {
        setSidebarOpen(lgUp);
    }, [lgUp]);

    const toggleSidebar = () => {
        setSidebarOpen((prev) => !prev);
    };

    const closeSidebar = () => {
        setSidebarOpen(false);
    };

    return (
        <>
            <DashboardLayoutRoot className="happy-admin-shell" isSidebarOpen={isSidebarOpen}>
                <Box
                    className="happy-admin-content"
                    sx={{
                        display: "flex",
                        flex: "1 1 auto",
                        flexDirection: "column",
                        width: "100%"
                    }}>
                    {children}
                </Box>
            </DashboardLayoutRoot>
            <DashboardNavbar
                isSidebarOpen={isSidebarOpen}
                onSidebarOpen={toggleSidebar}
                callback={toggleSidebar}
            />
            <DashboardSidebar
                show={props.customer}
                onClose={closeSidebar}
                callback={closeSidebar}
                open={isSidebarOpen}
            />
            <AdminAlerts />
            <LoginToast />
        </>
    );
};
